module.exports = __webpack_public_path__ + "SamsungOne-800C.2900e8debf849a10ce0c.ttf";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/SamsungOne-800C.ttf
// module id = ../../../../../src/assets/layout/fonts/SamsungOne-800C.ttf
// module chunks = styles